import React, { useEffect, useState } from 'react';
import { Button, DatePicker, Space, Spin } from 'antd';
import { RightOutlined, LoadingOutlined } from '@ant-design/icons';
import { CustomPaginate } from '../utils/Utils';
import apiConnect from '../../config/apiConfig';
import locale from 'antd/es/date-picker/locale/es_ES';
import moment from 'moment';
import style from './sells.module.scss';
import ModalOrderInfo from './modalInfo/ModalOrderInfo';

const Sells = () => {
  const {
    container,
    spin,
    tableContainer,
    title,
    count,
    table,
    tableHeader,
    itemsHeader,
    tableBody,
    itemsBody,
    btnModal,
    datePicker,
    paginationLayout,
    loadingContainer,
  } = style;

  const [dateFilter, setDateFilter] = useState();
  const [orders, setOrders] = useState([]);
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [drawerInfo, setDrawerInfo] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const iconSpin = <LoadingOutlined spin className={spin}/>;
  const { RangePicker } = DatePicker;

  function disabledDate(current) {
    return current && current > moment().endOf('day');
  }

  const handleOpenDrawer = order => {
    setDrawerInfo({
      order: order
    });
    setVisible(!visible);
  };

  useEffect(() => {
    const getOrders = async () => {
      try {
        setLoading(true);
        const reqParams = dateFilter
          ? `/orders?page=${currentPage}&dateSince=${dateFilter[0]}&dateTo=${dateFilter[1]}`
          : `/orders?page=${currentPage}`;
        const { data } = await apiConnect.get(reqParams);
        setOrders(data.data[0].orders);
        setTotalPages(data.data[0].totalPages);
        setLoading(false);
      } catch (error) {
        console.log(error); // eslint-disable-line
      }
    };

    getOrders();
  }, [dateFilter, currentPage]);

  function onChange(value) {
    setCurrentPage(1);
    if (value) {
      setDateFilter([
        value[0].format('YYYY-MM-DD'),
        value[1].format('YYYY-MM-DD'),
      ]);
    } else {
      setDateFilter(false);
    }
  }

  return (
    <div className={container}>
      <div className={tableContainer}>
        <h2 className={title}>
          Ventas realizadas
          <span className={count}>({orders.length})</span>
        </h2>
        <Space className={datePicker} direction="vertical" size={12}>
          <RangePicker
            disabledDate={disabledDate}
            format="DD-MM-YYYY"
            onChange={onChange}
            locale={locale}
          />
        </Space>
        {loading ? (
          <div className={loadingContainer}>
            <Spin indicator={iconSpin} />
          </div>
        ) : (
          <table className={table}>
            <thead>
              <tr className={tableHeader}>
                <th className={itemsHeader}>N° de orden</th>
                <th className={itemsHeader}>Fecha pedido</th>
                <th className={itemsHeader}>Farmacia</th>
                <th className={itemsHeader}>Unidades vendidas</th>
                <th className={itemsHeader}>Total sin descuento</th>
                <th className={itemsHeader}>Total con descuento</th>
              </tr>
            </thead>
            <tbody>
              {orders.length === 0? (
                <tr>
                  <td colSpan={6}  style={{textAlign: 'center'}}>No se encontraron ventas en este periodo</td>
                </tr>
              ) : (
                <></>
              )}
              {orders.map((ord) => {
                return (
                  <tr key={ord._id} className={tableBody}>
                    <td className={itemsBody}> # {ord.orderNumber}</td>
                    <td className={itemsBody}>{moment(ord.createdAt).format('L')}</td>
                    <td className={itemsBody}>{ord.pharmacyUser.pharmacy?.name || ord.pharmacyUser.accountNumber}</td>
                    <td className={itemsBody}>{ord.products.reduce((acc, curr) => {
                      return acc + curr.quantity;
                    }, 0)}</td>
                    <td className={itemsBody}>$ {parseFloat(ord.orderSubtotal).toFixed(2)}</td>
                    <td className={itemsBody}>$ {parseFloat(ord.orderTotalWithDiscount).toFixed(2)}</td>
                    <td className={itemsBody}>
                      <Button
                        className={btnModal}
                        onClick={() => handleOpenDrawer(ord)}
                      >
                        <RightOutlined />
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
      <div className={paginationLayout}>
        <CustomPaginate
          setPage={setCurrentPage}
          page={currentPage}
          totalPages={totalPages}
          isSells={true}
        />
      </div>
      <ModalOrderInfo dataOrder={drawerInfo?.order} state={visible} set={setVisible}/>
    </div>
  );
};

export default Sells;
